/*
 * @Author: 王佳宾
 * @Date: 2022-09-28 09:31:23
 * @LastEditors: 王佳宾
 * @LastEditTime: 2022-10-18 09:38:47
 * @Description: 常用工具接口
 * @FilePath: \src\api\utils\utilsApi.js
 */
import axios from '@/utils/request';
import config from '@/config/config';
import qs from 'qs';
const {
  serveIp: { mine_ip, pdf_ip },
} = config;

/** 获取钻井列表接口 */
export const getPageApi = (body, option) => axios.post(`${mine_ip}/hole/page`, body, option);
/** 查看钻井信息详情 */
export const getInfoApi = (params) => {
  // return config.isRequestError(axios.get(`${mine_ip}/hole/info/${params}`));
  return axios.get(`${mine_ip}/hole/info/${params}`);
};
/** 新增钻井信息接口 */
export const saveApi = (params) => {
  return config.isRequestError(axios.post(`${mine_ip}/hole/save`, params));
};
/** 修改钻井 */
export const updateApi = (params) => {
  return config.isRequestError(axios.put(`${mine_ip}/hole/update`, params));
};
/** 导出钻井信息 */
export const exportApi = (
  params,
  body,
  option
) => {
  return axios.post(
    `${mine_ip}/hole/export?${params}`,
    body,
    Object.assign({
      responseType: 'blob',
    }, option)
  );
};
/** 删除钻井信息 */
export const deleteApi = (data) => {
  return config.isRequestError(axios.delete(`${mine_ip}/hole/delete`, { data }));
};
/* 导入 */
export const industryImportApi = (params) => {
  return config.isRequestError(axios.post(`${mine_ip}/upload/hole`, params));
};

/** 获取字典信息 */
export const getDicInfoApi = (body, option) => axios.post(`${mine_ip}/dic/info?` + body, '', option);
/** 获取项目级别 */
export const getProjectLevel = () => {
  return new Promise((resolve, reject) => {
    resolve([
      {
        name: '重大项目',
        value: '重大项目',
      },
      {
        name: '一般项目',
        value: '一般项目',
      },
      {
        name: '推介项目',
        value: '推介项目',
      },
    ]);
  });
};
/** 获取开发阶段 */
export const getProjectStages = () => {
  return new Promise((resolve, reject) => {
    resolve([
      {
        label: '勘探',
        options: [
          {
            value: '高级勘探',
            label: '高级勘探',
          },
          {
            value: '勘探',
            label: '勘探',
          },
          {
            value: '草根',
            label: '草根',
          },
          {
            value: '靶区圈定',
            label: '靶区圈定',
          },
          {
            value: '勘查',
            label: '勘查',
          },
        ],
      },
      {
        label: '筹建',
        options: [
          {
            value: '委托中',
            label: '委托中',
          },
          {
            value: '计划建设',
            label: '计划建设',
          },
          {
            value: '可行性研究 ',
            label: '可行性研究 ',
          },
          {
            value: '可行性研究完成',
            label: '可行性研究完成',
          },
          {
            value: '可行性研究开始',
            label: '可行性研究开始',
          },
          {
            value: '预可行性研究',
            label: '预可行性研究',
          },
          {
            value: '筹建',
            label: '筹建',
          },
          {
            value: '矿量开发',
            label: '矿量开发',
          },
        ],
      },
      {
        label: '建设',
        options: [
          {
            value: '开始建设',
            label: '开始建设',
          },
          {
            value: '在建',
            label: '在建',
          },
        ],
      },
      {
        label: '生产',
        options: [
          {
            value: '扩产',
            label: '扩产',
          },
          {
            value: '限产',
            label: '限产',
          },
          {
            value: '生产',
            label: '生产',
          },
          {
            value: '预生产',
            label: '预生产',
          },
          {
            value: '剩余产量开发',
            label: '剩余产量开发',
          },
          {
            value: '外围开采',
            label: '外围开采',
          },
        ],
      },
      {
        label: '停产',
        options: [
          {
            value: '停产',
            label: '停产',
          },
          {
            value: '闭坑',
            label: '闭坑',
          },
          {
            value: '关闭',
            label: '关闭',
          },
        ],
      },
      {
        label: '未知',
        options: [
          {
            value: '未知',
            label: '未知',
          },
        ],
      },
    ]);
  });
};

/** 获取pdf */
export const getPdfUrlApi = (id) => {
  return `${pdf_ip}/${id}.pdf`;
};
